/**
 * Гард сессии. Токены лежат в localStorage, а пользователь — нет: после
 * перезагрузки его надо дочитать из `/me`, иначе сайдбар не знает, кто вошёл,
 * а `can()` считает, что прав нет вовсе.
 */
import type { Router } from 'vue-router'

import { useAuthStore } from './store'

declare module 'vue-router' {
  interface RouteMeta {
    /** Экран доступен без сессии */
    public?: boolean
    /** Ключ i18n для заголовка и крошек */
    titleKey?: string
    /** Право `resource:action`, без которого экран отдаёт 403 */
    permission?: string
  }
}

/** Право, без которого в трекере не работает ни один запрос */
const APP_PERMISSION = 'tracker:read'

export const setupAuthGuard = (router: Router) => {
  router.beforeEach(async (to) => {
    const auth = useAuthStore()

    if (to.meta.public) {
      // Вошедшему на форме входа делать нечего.
      return auth.isAuthenticated && to.name === 'login' ? { path: '/my' } : true
    }

    if (!auth.isAuthenticated) {
      return { name: 'login', query: { redirect: to.fullPath } }
    }

    if (!auth.user) {
      try {
        await auth.loadUser()
      } catch {
        // Токен есть, но сессия мертва: интерцептор её уже не спас.
        auth.reset()

        return { name: 'login', query: { redirect: to.fullPath } }
      }
    }

    // Право проверяется после загрузки пользователя: до неё прав нет ни у
    // кого, и гард отправлял бы на 403 даже владельца экрана.
    if (to.meta.permission && !auth.can(to.meta.permission)) {
      return { name: 'forbidden' }
    }

    // Трекер целиком живёт за одним правом: все 103 метода его API гейтятся
    // ресурсом `tracker`. Без него человек попадал на пустые экраны под живыми
    // пунктами меню и молча получал отказ на каждый запрос (DEV-2136).
    if (to.name !== 'forbidden' && !auth.can(APP_PERMISSION)) {
      return { name: 'forbidden' }
    }

    return true
  })
}
